// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Ycvt","productName":"Table_productName__kC-mf"};